import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadUsers } from './../../../../ng2/store/actions/users-actions';
import { getCurrentUser } from './../../../../ng2/store/selectors/current-user-selectors';
import { getUsersLoadedStatus } from './../../../../ng2/store/selectors/users-selectors';

@Injectable()
export class UserResolver {
  resolveUser$(userId, store): Promise<Observable<any>> {
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(getUsersLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadUsers(userId));
          if (loaded) {
            const user$ = store.select(getCurrentUser);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(user$);
          }
        });
    });
  }
}
